import styled from 'styled-components';

export const Title = styled.h2`
  color: white;
  text-align: center;
  font-weight: bold;
  margin-bottom: 30px;
`;
